<!-- GLOBAL SEARCH -->
<div class="toolbar">
  <button mat-icon-button (click)="openBillingPageHelp()">
    <mat-icon style="font-size: 30px" matTooltip="{{ 'btn.help' | translate }}">help_outline</mat-icon>
  </button>
  <div class="spacer"></div>
  <div class="right">
    <button
      mat-stroked-button
      (click)="onSwitchAggregatedView()"
      matTooltip="{{ (aggregatedView ? 'billingPage.listView' : 'billingPage.aggregatedView') | translate }}"
    >
      <mat-icon>{{ aggregatedView ? "view_headline" : "filter_none" }}</mat-icon>
    </button>
    <button mat-stroked-button (click)="activateCheckBox()" matTooltip="{{ 'page.patientlist.multiSelect' | translate }}">
      <mat-icon>check_box</mat-icon>
    </button>
    <button
      mat-stroked-button
      (click)="recalculateAdherence()"
      matTooltip="{{ 'page.patientlist.recalculateAll' | translate }}"
      *ngIf="('dashboard/chargeItemsCheckCriteria' | isAuthorized : 'PUT' | async) === true"
    >
      <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-calculator"></mat-icon>
    </button>
    <button
      mat-stroked-button
      (click)="clearFilter()"
      matTooltip="{{ 'itemFilter.clearAll' | translate }}"
      *ngIf="(responsiveService.isHandset$ | async) === false"
    >
      <img class="custom-icon" src="assets/images/custom-icon/clear-filter.png" />
    </button>

    <app-item-selector
      [items]="availableColumnItems"
      [translate]="true"
      (changed)="availableColumnChanged($event)"
      matTooltip="{{ 'page.patientlist.columnsSelect' | translate }}"
    >
    </app-item-selector>
  </div>
</div>

<!-- MULTI SELECT -->
<div class="toolbar mat-elevation-z8" *ngIf="actionOnMultiple" style="position: relative; z-index: 1; width: 100%">
  <button
    *ngIf="('dashboard/exportChargeItem' | isAuthorized | async) === true"
    mat-stroked-button
    [disabled]="!hasCheckboxTicked"
    (click)="downloadSelected()"
  >
    {{ "btn.download" | translate }}
  </button>
  <button
    *ngIf="('dashboard/sendChargeItems' | isAuthorized : 'POST' | async) === true"
    mat-stroked-button
    [disabled]="!hasCheckboxTicked"
    (click)="billSelected()"
  >
    {{ "btn.bill" | translate }}
  </button>

  <button mat-stroked-button *ngIf="commonTransitions?.includes(BILLING_TYPE.BILLABLE)" (click)="bulkUpdateStatus(BILLING_TYPE.BILLABLE)">
    {{ "billing.actions.markAsBillable" | translate }}
  </button>

  <button
    mat-stroked-button
    *ngIf="commonTransitions?.includes(BILLING_TYPE.NOT_BILLABLE)"
    (click)="bulkUpdateStatus(BILLING_TYPE.NOT_BILLABLE)"
  >
    {{ "billing.actions.markAsNotBillable" | translate }}
  </button>

  <button mat-stroked-button *ngIf="commonTransitions?.includes(BILLING_TYPE.PLANNED)" (click)="bulkUpdateStatus(BILLING_TYPE.PLANNED)">
    {{ "billing.actions.markAsPlanned" | translate }}
  </button>
  <button
    *ngIf="('dashboard/chargeItemsCheckCriteria' | isAuthorized : 'PUT' | async) === true"
    mat-stroked-button
    [disabled]="!hasCheckboxTicked"
    (click)="recalculateAdherence()"
  >
    {{ "billing.actions.recalculateAdherence" | translate }}
  </button>
</div>

<!-- Active filter list -->
<app-filters-display *ngIf="!isMobile" [filters]="this.filters" [parent]="'patientList'" (removeFilter)="applyFilter($event)">
</app-filters-display>

<mat-card [ngClass]="{ 'm-0': isMobile }">
  <!--
    We use the same dataSource for app-invoice-list and app-invoice-table.
    When switching from desktop to phone mode, the data are not rendered in the table if we just use the datasource
    Therefore, we pass "data" to this two children.
  -->

  <app-invoice-summary
    *ngIf="healthcareServicesRefs?.length && !isLoading && !aggregatedView"
    [pageNumber]="paginator?.pageIndex"
    [pageSize]="paginator?.pageSize"
    [services]="healthcareServicesRefs"
    [visibleData]="data"
  ></app-invoice-summary>
  <!-- List for smartphone view -->
  <app-invoice-list *ngIf="isMobile && !aggregatedView && !isLoading" [data]="data"></app-invoice-list>
  <!-- Table for desktop view -->
  <app-invoice-table
    *ngIf="!isMobile && !aggregatedView && !isLoading"
    (sortChanged)="onSortChanged($event)"
    (filterChanged)="applyFilter($event)"
    [dataSource]="dataSource"
    [activeFilters]="activeFilters"
    [data]="data"
    (send)="onSend($event)"
    (updateStatus)="onUpdateStatus($event)"
    (reload)="loadData()"
    [availableColumnItems]="availableColumnItems"
    (changeColumnOrder)="changeColumnOrder($event)"
  ></app-invoice-table>
  <!-- Aggregated table view (group by patient) -->
  <app-invoice-aggregated-table
    *ngIf="aggregatedView && !isLoading"
    [data]="data"
    (send)="onSend($event)"
    (updateStatus)="onUpdateStatus($event)"
    (reload)="loadData()"
  ></app-invoice-aggregated-table>
  <!-- Paginator is common to both views -->
  <mat-paginator *ngIf="!aggregatedView" [length]="totalCount" [pageSize]="25" [pageSizeOptions]="[25, 50, 100, 250]"> </mat-paginator>
</mat-card>
